import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injectable, ErrorHandler } from '@angular/core';

import { AppRoutingModule } from './app-rounting.module';

import { AppComponent } from './app.component';
import { Page4Component } from './components/page4/page4.component';
import { Page3Component } from './components/page3/page3.component';
import { HomepageComponent } from './components/homepage/homepage.component';
import { AboutComponent } from './components/about/about.component';
import { LegalComponent } from './dialogs/legal/legal.component';
import { IbmcognosComponent } from './components/ibmcognos/ibmcognos.component';
import { DesignComponent } from './components/design/design.component';
import { EnterpriseApplicationComponent } from './components/enterprise-application/enterprise-application.component';
import { CodeingComponent } from './components/codeing/codeing.component';
import { DataService } from './services/data.service';
import { Page4dayComponent } from './components/page4day/page4day.component';
import { WhoDoWeWorkForComponent } from './components/who-do-we-work-for/who-do-we-work-for.component';
import { WhoDoWeWorkForDayComponent } from './components/who-do-we-work-for-day/who-do-we-work-for-day.component';
import { WhoWeAreComponent } from './components/who-we-are/who-we-are.component';
import { EmployeesService } from './components/employees/employees.service';
import { ContactComponent } from './components/contact/contact.component';
import { AmvaraClockComponent } from './components/amvara-clock/amvara-clock.component';
import { AmvaraVideoComponent } from './components/amvara-video/amvara-video.component'
import { EmployeeInformationComponent } from './components/employee-information/employee-information.component';
import { AboutNightComponent } from './components/about-night/about-night.component';
import { FlattenPdfComponent } from './components/flatten-pdf/flatten-pdf.component';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
// import * as Hammer from 'hammerjs';
// import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';

import { EmployeePicturePipe } from './pipes/employee-picture.pipe';
import { TranslocoRootModule } from './i18n/transloco-root.module';
import { LanguageService } from './i18n/language.service';

/**
 * Browser Sentry is disabled: self-hosted Sentry 9.x rejects SDK 8 `/envelope`
 * requests with CSRF 403, which fails Lighthouse "Best Practices" (console errors).
 * Re-enable after upgrading Sentry server, or pin an SDK that uses `/store`.
 */
@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {}
  handleError(error) {
    // Keep local visibility without network noise
    // eslint-disable-next-line no-console
    console.error(error?.originalError || error);
  }
}

/* @Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any> {
    'swipe': { direction: Hammer.DIRECTION_VERTICAL }
  };
  buildHammer(element: HTMLElement) {
    const mc = new Hammer(element, {
      touchAction: 'pan-y',
    });
    return mc;
  }
} */


@NgModule({
    declarations: [
        AppComponent,
        HomepageComponent,
        AboutComponent,
        Page3Component,
        Page4Component,
        LegalComponent,
        IbmcognosComponent,
        DesignComponent,
        EnterpriseApplicationComponent,
        CodeingComponent,
        Page4dayComponent,
        WhoDoWeWorkForComponent,
        WhoDoWeWorkForDayComponent,
        WhoWeAreComponent,
        WhoWeAreComponent,
        ContactComponent,
        AmvaraClockComponent,
        AmvaraVideoComponent,
        EmployeeInformationComponent,
        AboutNightComponent,
        FlattenPdfComponent,
        EmployeePicturePipe,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ReactiveFormsModule,
        AppRoutingModule,
        MatDialogModule,
        MatButtonModule,
        MatExpansionModule,
        TranslocoRootModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    ],
    providers: [
        DataService,
        EmployeesService,
        LanguageService,
        { provide: ErrorHandler, useClass: SentryErrorHandler },
        /* {
          provide: HAMMER_GESTURE_CONFIG,
          useClass: MyHammerConfig
        } */
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
